import { motion } from "framer-motion";
import { Phone, Mail, MapPin, MessageCircle, Clock } from "lucide-react";
import { brand } from "@/mock";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut", delay: i * 0.12 },
  }),
};

export const Contact = () => {
  const waLink = `https://wa.me/${brand.whatsapp}?text=${encodeURIComponent(
    "Përshëndetje, kam nevojë për asistencë për një shërbim funebër."
  )}`;

  const infos = [
    { icon: Phone, label: "Telefon (Shqipëri)", value: brand.phoneDisplay, href: `tel:+${brand.whatsapp}` },
    { icon: Phone, label: "Telefon (Itali)", value: brand.phoneItalyDisplay, href: `tel:+${brand.phoneItaly}` },
    { icon: Mail, label: "Email", value: brand.email, href: `mailto:${brand.email}` },
    { icon: MapPin, label: "Selia", value: brand.address, href: null },
    { icon: MapPin, label: "Seli Operative", value: brand.italyOffice, href: null },
    { icon: Clock, label: "Disponibiliteti", value: "24 orë në 24, 7 ditë në javë", href: null },
  ];

  return (
    <section
      id="contatti"
      data-testid="contact-section"
      className="relative py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[#0A0A0A] overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(212,175,55,0.10),transparent_55%)]" />
        <img
          src={brand.logo}
          alt=""
          aria-hidden="true"
          className="pointer-events-none select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[720px] max-w-[110%] opacity-[0.06] grayscale"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          <p className="text-sm tracking-[0.2em] uppercase text-[#D4AF37] mb-4">
            Kontakt
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F5F5F5] tracking-tight leading-tight">
            Jemi pranë jush, në çdo moment
          </h2>
          <p className="mt-5 text-base text-gray-400 leading-relaxed max-w-lg">
            Na kontaktoni për çdo nevojë. Personeli ynë është në dispozicion
            ditë e natë për t'ju ofruar asistencë të menjëhershme, diskrete dhe
            me respekt.
          </p>

          <a
            data-testid="contact-whatsapp-btn"
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-3 bg-[#128C4B] text-white px-8 py-4 rounded-full text-sm tracking-wide font-medium hover:bg-[#0f7a41] transition-colors duration-300"
          >
            <MessageCircle size={20} strokeWidth={1.5} />
            Na shkruani në WhatsApp
          </a>
        </motion.div>

        <motion.div
          variants={fadeUp}
          custom={1}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="grid grid-cols-1 sm:grid-cols-2 gap-4"
        >
          {infos.map((info, i) => {
            const Icon = info.icon;
            const content = (
              <div
                data-testid={`contact-info-${i}`}
                className="h-full bg-[#1A1A1A] border border-[#D4AF37]/20 rounded-2xl p-6 hover:border-[#D4AF37]/60 transition-colors duration-500"
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-[#D4AF37]/40 text-[#D4AF37]">
                  <Icon size={20} strokeWidth={1.5} />
                </span>
                <p className="mt-4 text-xs tracking-wide uppercase text-gray-500">
                  {info.label}
                </p>
                <p className="mt-1 text-base text-[#F5F5F5]">{info.value}</p>
              </div>
            );
            return info.href ? (
              <a key={i} href={info.href} className="block h-full">
                {content}
              </a>
            ) : (
              <div key={i}>{content}</div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
